// extracted by mini-css-extract-plugin
export default {"date_button_container":"your-birthdate_date_button_container__SOJDz","date_button":"your-birthdate_date_button__Loiac","error_text":"your-birthdate_error_text__OxPZT"};